module.exports = __webpack_public_path__ + "img/石林1_1.05e91d67.jpg";